export const serviceGet = (params, url, proxy) => {
  return new Promise((resolve, reject) => {
    const urlToService = new ServicioProxyTransar(url, proxy);
    urlToService
      .getElements('POST', params)
      .then((response) => {
        if (response) {
          const data = JSON.parse(response);
          resolve(data);
        } else {
          reject(Error('Error en la consulta'));
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const compensarLoader = (isLoading) =>
  isLoading ? compensar.mostrarLoading('.selectorPadre') : compensar.quitarLoading('.selectorPadre');
